import { render, staticRenderFns } from "./TableroReparaciones.vue?vue&type=template&id=3d22629b&scoped=true"
import script from "./TableroReparaciones.vue?vue&type=script&lang=js"
export * from "./TableroReparaciones.vue?vue&type=script&lang=js"
import style0 from "./TableroReparaciones.vue?vue&type=style&index=0&id=3d22629b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d22629b",
  null
  
)

export default component.exports